import Repository from './Repository'

const URL_MAINTENANCE = '/admin/system-maintenance-schedule'

export default {
  async checkMaintenanceAsync () {
    try {
      await Repository.get(`${URL_MAINTENANCE}/check`)
      return { maintenance: false } // No maintenance
    } catch (error) {
      if (error.response && error.response.status === 503) {
        return { maintenance: true } // Still in maintenance mode
      }
      throw error // Re-throw other errors
    }
  },
}
